module.exports = __webpack_public_path__ + "media/images/smart_phone/products/chicken2-eef24cdc82194cf81ce53724dbcad32b.jpeg";